// removed by extract-text-webpack-plugin
module.exports = {"burgerBtn":"BurgerDropDownMenu__burgerBtn___1N2eU"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BurgerDropDownMenu/BurgerDropDownMenu.scss
 ** module id = 876
 ** module chunks = 0
 **/